import $h056i$intllabelarAEmjs from "../intl/label/ar-AE.mjs";
import $h056i$intllabelbgBGmjs from "../intl/label/bg-BG.mjs";
import $h056i$intllabelcsCZmjs from "../intl/label/cs-CZ.mjs";
import $h056i$intllabeldaDKmjs from "../intl/label/da-DK.mjs";
import $h056i$intllabeldeDEmjs from "../intl/label/de-DE.mjs";
import $h056i$intllabelelGRmjs from "../intl/label/el-GR.mjs";
import $h056i$intllabelenUSmjs from "../intl/label/en-US.mjs";
import $h056i$intllabelesESmjs from "../intl/label/es-ES.mjs";
import $h056i$intllabeletEEmjs from "../intl/label/et-EE.mjs";
import $h056i$intllabelfiFImjs from "../intl/label/fi-FI.mjs";
import $h056i$intllabelfrFRmjs from "../intl/label/fr-FR.mjs";
import $h056i$intllabelheILmjs from "../intl/label/he-IL.mjs";
import $h056i$intllabelhrHRmjs from "../intl/label/hr-HR.mjs";
import $h056i$intllabelhuHUmjs from "../intl/label/hu-HU.mjs";
import $h056i$intllabelitITmjs from "../intl/label/it-IT.mjs";
import $h056i$intllabeljaJPmjs from "../intl/label/ja-JP.mjs";
import $h056i$intllabelkoKRmjs from "../intl/label/ko-KR.mjs";
import $h056i$intllabelltLTmjs from "../intl/label/lt-LT.mjs";
import $h056i$intllabellvLVmjs from "../intl/label/lv-LV.mjs";
import $h056i$intllabelnbNOmjs from "../intl/label/nb-NO.mjs";
import $h056i$intllabelnlNLmjs from "../intl/label/nl-NL.mjs";
import $h056i$intllabelplPLmjs from "../intl/label/pl-PL.mjs";
import $h056i$intllabelptBRmjs from "../intl/label/pt-BR.mjs";
import $h056i$intllabelptPTmjs from "../intl/label/pt-PT.mjs";
import $h056i$intllabelroROmjs from "../intl/label/ro-RO.mjs";
import $h056i$intllabelruRUmjs from "../intl/label/ru-RU.mjs";
import $h056i$intllabelskSKmjs from "../intl/label/sk-SK.mjs";
import $h056i$intllabelslSImjs from "../intl/label/sl-SI.mjs";
import $h056i$intllabelsrSPmjs from "../intl/label/sr-SP.mjs";
import $h056i$intllabelsvSEmjs from "../intl/label/sv-SE.mjs";
import $h056i$intllabeltrTRmjs from "../intl/label/tr-TR.mjs";
import $h056i$intllabelukUAmjs from "../intl/label/uk-UA.mjs";
import $h056i$intllabelzhCNmjs from "../intl/label/zh-CN.mjs";
import $h056i$intllabelzhTWmjs from "../intl/label/zh-TW.mjs";

var $c4535c22cbb991de$exports = {};


































$c4535c22cbb991de$exports = {
    "ar-AE": $h056i$intllabelarAEmjs,
    "bg-BG": $h056i$intllabelbgBGmjs,
    "cs-CZ": $h056i$intllabelcsCZmjs,
    "da-DK": $h056i$intllabeldaDKmjs,
    "de-DE": $h056i$intllabeldeDEmjs,
    "el-GR": $h056i$intllabelelGRmjs,
    "en-US": $h056i$intllabelenUSmjs,
    "es-ES": $h056i$intllabelesESmjs,
    "et-EE": $h056i$intllabeletEEmjs,
    "fi-FI": $h056i$intllabelfiFImjs,
    "fr-FR": $h056i$intllabelfrFRmjs,
    "he-IL": $h056i$intllabelheILmjs,
    "hr-HR": $h056i$intllabelhrHRmjs,
    "hu-HU": $h056i$intllabelhuHUmjs,
    "it-IT": $h056i$intllabelitITmjs,
    "ja-JP": $h056i$intllabeljaJPmjs,
    "ko-KR": $h056i$intllabelkoKRmjs,
    "lt-LT": $h056i$intllabelltLTmjs,
    "lv-LV": $h056i$intllabellvLVmjs,
    "nb-NO": $h056i$intllabelnbNOmjs,
    "nl-NL": $h056i$intllabelnlNLmjs,
    "pl-PL": $h056i$intllabelplPLmjs,
    "pt-BR": $h056i$intllabelptBRmjs,
    "pt-PT": $h056i$intllabelptPTmjs,
    "ro-RO": $h056i$intllabelroROmjs,
    "ru-RU": $h056i$intllabelruRUmjs,
    "sk-SK": $h056i$intllabelskSKmjs,
    "sl-SI": $h056i$intllabelslSImjs,
    "sr-SP": $h056i$intllabelsrSPmjs,
    "sv-SE": $h056i$intllabelsvSEmjs,
    "tr-TR": $h056i$intllabeltrTRmjs,
    "uk-UA": $h056i$intllabelukUAmjs,
    "zh-CN": $h056i$intllabelzhCNmjs,
    "zh-TW": $h056i$intllabelzhTWmjs
};


export {$c4535c22cbb991de$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
